import parser from 'ua-parser-js';
import * as _ from 'lodash-es';
import Fingerprint2 from 'fingerprintjs2';
import excmd5 from 'md5';
import * as request from '@api/request';

export const md5 = excmd5;

export const getReplaceText = (text, num) => {
  if (!text) return '';
  return text.replace(/\$\{n\}/g, num);
};

export const getUrlParams = (name) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return '';
};

export const getMainHost = () => {
  if (window.location.hostname == 'localhost') {
    return 'gnjoy.hk';
  }
  let hostArr = window.location.hostname.split('.');
  let mainArr = hostArr.slice(-2);
  return mainArr.join('.');
};

export const getCurYear = () => {
  return `${new Date().getFullYear()}`;
};

export const sdk = (action, params) => {
  if (!action) return;
  try {
    if (params !== void 0) {
      window.sdkCtrl[action](params);
    } else {
      window.sdkCtrl[action]();
    }
  } catch (error) {
    try {
      window.webkit.messageHandlers.callSDKMethodWithParameters.postMessage({
        method: action,
        params
      });
    } catch (_error) {}
  }
};

export const sleep = async (second) => {
  return new Promise((resolve) => {
    setTimeout(resolve, second * 1000);
  });
};

// 这个库一共可以识别console, mobile, tablet, smarttv, wearable, embedded，其中桌面是undefined。
export const isMobileType = () => {
  let info = parser();
  if (info) {
    if (info.device.type == undefined) return false;
    if (info.device.type == 'tablet' || info.device.type == 'smarttv') {
      return window.innerHeight > window.innerWidth;
    }
  }
  return true;
};

export const getDeviceInfo = () => {
  return parser();
};

export const getUrlParamObj = (ignoreKeyArr) => {
  let search = window.location.search.substr(1);
  let res = {};
  let keyArr = search.split('&');
  for (let i in keyArr) {
    let arr = keyArr[i].split('=');
    if (ignoreKeyArr?.length && _.isArray(ignoreKeyArr)) {
      let _i = ignoreKeyArr.findIndex((item) => item == arr[0]);
      if (~_i) continue;
    }
    res[arr[0]] = arr[1];
  }

  return res;
};

export const getSystemLanguage = function () {
  let res =
    navigator.language ||
    navigator.userLanguage ||
    navigator.browerLanguage ||
    navigator.systemLanguage;
  if (res.indexOf('-') > -1) {
    const langArr = res.split('-');
    res = langArr[0] === 'zh' ? langArr[1] : langArr[0];
  }
  return res.toLowerCase();
};

const createFingerPrint = async (data = {}) => {
  return new Promise((resolve) => {
    Fingerprint2.get((components) => {
      // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
      let values = components.map((component) => component.value); // 配置的值的数组
      for (let i in data) {
        values.push(data[i]);
      }
      const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
      resolve(murmur);
    });
  });
};

export const getFingerPrint = async (data = {}) => {
  let local = ''
  try {
    local = window.localStorage.getItem('finger_id_2')
  } catch (error) { }
  if (!local) {
    if (!Object.keys(data).length) {
      let testIpUrl = '//gcollectsecond.octlib.com/Index/GetLcsCode';
      request.ajax({ url: testIpUrl }).then(res => {
        if (
          parseInt(res.result, 10) === 1 &&
          Object.prototype.toString.call(res.data) == '[object Object]' &&
          Object.prototype.toString.call(res.data.info) == '[object Array]' &&
          res.data.info.length
        ) {
          data = res.data
        }
      });

    }
    local = await createFingerPrint(data)
    try {
      window.localStorage.setItem('finger_id_2', local)
    } catch (error) { }
  }
  return local
};

// 旧版通用的判断设备逻辑
export const getDeviceOld = () => {
  let userAgent = window.navigator.userAgent;
  let ua = userAgent.toLowerCase();
  let platform = {
    isAndroid: function () {
      return ua.indexOf('android') > -1;
    },
    isIOS: function () {
      let NPlatform = navigator.platform;
      return (
        ua.indexOf('iphone') > -1 ||
        /iPad|iPhone|iPod/gi.test(NPlatform) ||
        (NPlatform === 'MacIntel' &&
          navigator.maxTouchPoints > 1 &&
          !window.MSStream)
      );
    },
    isWinPhone: function () {
      return !!navigator.userAgent.match(/Windows Phone/i);
    },
    isIpad: function () {
      return ua.indexOf('ipad') > -1;
    },
    isPhone: function () {
      return (
        this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad()
      );
    }
  };
  return platform;
};

export const systemType = () => {
  let _p = getDeviceOld();
  if (_p.isIOS() || _p.isIpad()) return 'ios';
  if (_p.isAndroid() || _p.isWinPhone()) return 'android';
  return 'pc';
};

export const getGapi = (shost) => {
  return `${getMainHost() == 'gm99.com' ? '' : 'g'}${shost}.${getMainHost()}`;
};

export const setCookie = (name, value, days, safe) => {
  let date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + date.toGMTString();
  let safeTxt = 'Secure; SameSite=None;';
  if (safe) {
    safeTxt = '';
  }
  document.cookie = `${name}=${value};${expires};path=/;${safeTxt}domain=.${getMainHost()}`;
};

export const getCookie = (name) => {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  let arr = document.cookie.match(reg);
  if (arr) return arr[2];
  return '';
};

export const randomNumber = (min, max) => {
  const randomBuffer = new Uint32Array(1);
  window.crypto.getRandomValues(randomBuffer);
  const number = randomBuffer[0] / (0xffffffff + 1);
  return Math.floor(number * (max - min) + min);
};

// 更新链接参数
export const updateLinkParams = (link, obj, filterRepeat = false) => {
  try {
    let url = new URL(link);
    for (let k in obj) {
      if (filterRepeat && url.searchParams.has(k)) {
        continue;
      }
      url.searchParams.set(k, String(obj[k]));
    }
    return url.href;
  } catch (error) {
    return String(link);
  }
};

// 获取带有cid、scid的储值链接
export const getStoreLinkWithCidScid = ({ link, paramsObj, pageId }) => {
  if (!link) return '';
  let res = updateLinkParams(link);
  const cid = getUrlParams('cid');
  const scid = getUrlParams('scid');
  let storeLinkCid = 'web';
  let storeLinkScid = `activity_${pageId}`;
  if (cid) {
    storeLinkCid = cid;
  }
  if (scid) {
    storeLinkScid = `${scid}_activity_${pageId}`;
  }
  res = updateLinkParams(res, {
    cid: storeLinkCid,
    scid: storeLinkScid,
    ...paramsObj
  });
  return res;
};

// 活动及储值页的常用域名，用于替换链接中的域名
export const mainLinkArr = [
  'pay',
  'gabres',
  'gevents',
  'auto-page',
  'auto-page-preview'
];
// 二级域名包含活动及储值页的常用域名时标记为需要替换域名的链接
export const checkMainLink = (link) => {
  let hostArr = link.split('.');
  if (hostArr.length < 2) return false;
  let linkHost = hostArr[0];
  if (linkHost.indexOf('//') > -1) {
    linkHost = linkHost.split('//')[1];
  }
  return mainLinkArr.includes(linkHost);
};
// 获取最终跳转的链接
export const getTargetLink = (link) => {
  if (checkMainLink(link)) {
    // 替换link中的mainHost为当前域名中的mainHost
    let hostArr = link.split('.');
    hostArr[1] = window.location.hostname.split('.')[1];
    return hostArr.join('.');
  }
  return link;
};

// 这些都是新旧版本的兼容代码
export const getUrlParms = getUrlParams;
// export const getJSON = request.getJSON; // ❌ 注释掉，避免循环依赖。请直接从 @/api/request 导入 getJSON

// 只支持 global 平台
const link = {
  activity: `https://gactivityapi.${getMainHost()}/activity/execute`,
  getUserJson: `https://gpassport.${getMainHost()}/center/ajax/get_user_json`,
  logout: `https://gpassport.${getMainHost()}/web_login/logout`,
  loginUrl: `https://gabres.${getMainHost()}/platform/login.html`,
};

// 获取活动接口
export const getActivityApi = (platform, name, action) => {
  return updateLinkParams(link.activity, {
    name,
    action
  });
};

// 获取登录态接口
export const getUserJsonApi = (platform) => {
  return link.getUserJson;
};

// 获取登出接口
export const getLogoutApi = (platform) => {
  return link.logout;
};

// 获取登陆页链接
export const getLoginUrlApi = (platform, gameId, language = '') => {
  return updateLinkParams(link.loginUrl, {
    gameId,
    forward: encodeURIComponent(window.location.href),
    language
  });
};

// import getJSONP from '@api/http'

export function getParam(name, href) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let realparams = window.location.search.substr(1)
  if (href && href.indexOf('?') > -1) {
    realparams = href.split('?')[1]
  }
  const r = realparams.match(reg)

  if (r != null) return decodeURIComponent(r[2])
  return ''
}

export function convertParamToString(
  params
) {
  const paramArray = []
  for (const key in params) {
    let val = params[key]
    if (typeof val === 'object') {
      val = JSON.stringify(val)
    }
    const param = key + '=' + val
    paramArray.push(param)
  }
  paramArray.push('callback')
  if (paramArray.length > 0) {
    return paramArray.join('&')
  }
  return ''
}

// // 获取图片
// export const getImageUrl = name => {
//   return new URL(`../assets/images/award/${name}`, import.meta.url).href
// }
// 获取域名
export const getCurrentHost = () => {
  const matchHost = window.location.host.match(/\.?([A-za-z0-9]*\.(com|hk))/)
  return matchHost ? matchHost[1] : 'gnjoy.hk'
}
// 获取当前平台
export const getBranch = () => {
  return window.location.hostname.split('.')[1]
}
// export const getPlatform = (): string => {
//   const branch = getBranch()
//   const platformMap: Record<string, string> = {
//     gm99: 'gm99'
//   }
//   return platformMap[branch] || 'global'
// }

// 创建节流函数
export const throttle = (cb, time = 300) => {
  let timer;
  let bool = false
  return () => {
    if (bool) {
      return
    }
    bool = true
    clearTimeout(timer)
    timer = setTimeout(() => {
      cb()
      bool = false
    }, time)
  }
}

// 创建防抖函数
export const antiShake = (cb, time = 300) => {
  let timer;
  return () => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      cb()
    }, time)
  }
}

// 验证有无登录 跳转 start

export const HOST = getCurrentHost()

// const ajaxUrl = {
//   checkLogin: {
//     global: `//gpassport.${HOST}/center/ajax/get_user_json`,
//     gm99: '//passport.gm99.com/ajax/get_user_json'
//   },
//   logout: {
//     global: `//gpassport.${HOST}/web_login/logout`,
//     gm99: '//passport.gm99.com/login/logout2'
//   },
//   server: {
//     global: `//gactivityapi.${HOST}/activity/execute?name=${window.aid}&action=listServerNew`,
//     gm99: `//eventsapi.gm99.com/activity/execute?name=${window.aid}&action=listServerNew`
//   },
//   role: {
//     global: `//gactivityapi.${HOST}/activity/execute?name=${window.aid}&action=getMobileGameRole`,
//     gm99: `//eventsapi.gm99.com/activity/execute?name=${window.aid}&action=getMobileGameRole`
//   }
// }
// const PLATFORM = getPlatform()
// const loginPageMap = {
//   global: `//gabres.${HOST}/platform/login.html?forward=${encodeURIComponent(
//     window.location.href
//   )}`,
//   gm99: `//passport.gm99.com/?device=${
//     window.platform.isPhone() ? '2' : '1'
//   }&forward=${encodeURIComponent(window.location.href)}`
// }
// export const loginLink = loginPageMap[PLATFORM]
// // end

export const getShareImg = lang => {
  return new URL(`../assets/images/share/${lang}.jpg`, import.meta.url).href
}

/**
 * 判断设备是否为竖屏（Portrait）方向
 * 通过宽高比判断，兼容性好且准确
 * @returns {boolean} true: 竖屏, false: 横屏
 */
export const isPortrait = () => {
  // 方法1: 使用宽高比判断（最可靠，兼容性最好）
  // innerWidth/innerHeight 会根据实际可视区域动态变化
  const width = window.innerWidth
  const height = window.innerHeight
  
  // 竖屏：高度 > 宽度
  if (height > width) {
    return true
  }
  
  // 横屏：宽度 > 高度
  if (width > height) {
    return false
  }
  
  // 方法2: 如果宽高相等（极少见），尝试使用 orientation API
  // screen.orientation.type (现代浏览器)
  if (window.screen && window.screen.orientation && window.screen.orientation.type) {
    const type = window.screen.orientation.type
    return type.includes('portrait')
  }
  
  // 方法3: 降级到 window.orientation (iOS Safari 旧版本)
  // 0 或 180 为竖屏，90 或 -90 为横屏
  if (typeof window.orientation !== 'undefined') {
    return window.orientation === 0 || window.orientation === 180
  }
  
  // 方法4: 使用 matchMedia 查询
  if (window.matchMedia) {
    const isPortraitMedia = window.matchMedia('(orientation: portrait)').matches
    if (typeof isPortraitMedia === 'boolean') {
      return isPortraitMedia
    }
  }
  
  // 默认返回 true（竖屏），因为移动设备默认为竖屏
  return true
}

/**
 * 判断设备是否为横屏（Landscape）方向
 * @returns {boolean} true: 横屏, false: 竖屏
 */
export const isLandscape = () => {
  return !isPortrait()
}

/**
 * 监听屏幕方向变化
 * @param {Function} callback - 回调函数，接收参数 { isPortrait: boolean, isLandscape: boolean }
 * @returns {Function} 取消监听的函数
 * 
 * @example
 * const unwatch = watchOrientation((orientation) => {
 *   console.log('当前方向:', orientation.isPortrait ? '竖屏' : '横屏')
 * })
 * // 取消监听
 * unwatch()
 */
export const watchOrientation = (callback) => {
  if (typeof callback !== 'function') {
    console.warn('watchOrientation: callback must be a function')
    return () => {}
  }

  const handleOrientationChange = () => {
    const portrait = isPortrait()
    callback({
      isPortrait: portrait,
      isLandscape: !portrait
    })
  }

  // 多种事件监听，确保兼容性
  const events = ['orientationchange', 'resize']
  
  events.forEach(event => {
    window.addEventListener(event, handleOrientationChange, { passive: true })
  })

  // 立即执行一次回调
  handleOrientationChange()

  // 返回取消监听的函数
  return () => {
    events.forEach(event => {
      window.removeEventListener(event, handleOrientationChange)
    })
  }
}

// 判断设备类型
export const deviceType = function () {
  const userAgent = window.navigator.userAgent;
  const ua = userAgent.toLowerCase();
  const platform = {
    isAndroid: function () {
      return ua.indexOf('android') > -1;
    },
    isIOS: function () {
      return ua.indexOf('iphone') > -1;
    },
    isWinPhone: function () {
      return !!navigator.userAgent.match(/Windows Phone/i);
    },
    isIpad: function () {
      var NPlatform = navigator.platform;
      return (
        /iPad/gi.test(NPlatform) ||
        (NPlatform === 'MacIntel' &&
          navigator.maxTouchPoints > 1 &&
          !window.MSStream)
      );
    },
    isPhone: function () {
      return (
        this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad()
      );
    },
    isIE11: function () {
      return (
        userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
      );
    },
    isEdge: function () {
      return userAgent.indexOf('Edge') > -1;
    },
  };
  if (!platform.isPhone() || platform.isIE11() || platform.isEdge()) {
    return 'pc';
  }
  if (platform.isIOS() || platform.isIpad()) {
    return 'ios';
  }
  if (platform.isAndroid()) {
    return 'android';
  }
  return '其他';
}

/**
 * 打点上报函数
 * @param {Object} data - 打点数据
 * @param {string} data.eventName - 事件名称，如 'show_popup', 'view_page', 'click_button'
 * @param {string} data.eventType - 事件类型，如弹窗名称、页面名称等
 * @param {string} [data.eventReason] - 事件原因（可选）
 * @param {string} [data.uid] - 用户ID（可选，只需上报一次）
 * @param {string} [data.loginAccount] - 登录账号（可选，只需上报一次）
 * @param {string} [data.roleId] - 角色ID（可选，只需上报一次）
 * @param {string} [data.roleName] - 角色名称（可选，只需上报一次）
 * @param {string} [data.serverId] - 服务器ID（可选，只需上报一次）
 */
export const point = (data) => {
  if (!data) {
    throw new Error("请传入打点上报参数");
  }

  const biParams = {
    ...data,
    aid: window.activity_name,
    gameId: window.game_id,
  };

  // 只需要上报一次的参数, 调用该方法时传入就自动加上这些参数上报
  const onceParamArr = [
    "uid",
    "loginAccount",
    "roleId",
    "roleName",
    "serverId",
  ];
  for (let i = 0, len = onceParamArr.length; i < len; i++) {
    const onceParamArrItem = onceParamArr[i];
    const paramValue = data[onceParamArrItem];
    if (paramValue) {
      Object.defineProperty(biParams, onceParamArrItem, {
        value: paramValue,
        writable: true,
        enumerable: true,
      });
    }
  }

  if (process.env.NODE_ENV === "development") {
    console.log("活动BI打点上报：", biParams);
  }

  try {
    // 上报BI的
    window.activityDataLayer.push(biParams);
  } catch (error) {
    console.error(error);
  }
}

/**
 * 按钮点击打点上报
 * @param {string} eventType - 按钮名称
 * @param {string} eventReason - 按钮所在的页面
 */
export const pointClickButton = (eventType, eventReason) => {
  point({
    eventName: 'click_button',
    eventType,
    eventReason,
  });
}

/**
 * 初始化 globalAdPoint
 * 用于广告追踪和转化统计
 */
export const initGlobalAdPoint = () => {
  if (!window.globalAdPoint || typeof window.globalAdPoint.init !== 'function') {
    console.warn('globalAdPoint not available');
    return;
  }

  try {
    window.globalAdPoint.init({
      platformId: '8',
      gameId: 386,
      pageId: 'row_reservation_01',
      abTestVersion: 'default',
      pageType: 2,
    });
  } catch (error) {
    console.error('Failed to initialize globalAdPoint:', error);
  }
}